<template>
  <el-dialog
    title="另存为模板"
    :visible.sync="tempDialogVisible"
    :append-to-body="true"
    width="600px"
    @close="closeWin"
    style="z-index: 9999"
  >
    <div class="jdialog-content">
      <el-form :model="tempData" status-icon ref="ruleForm" label-width="100px">
        <el-form-item label="模板类型" prop="name">
          <el-input
            type="text"
            v-model="tempData.name"
            :disabled="disabled"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板内容" prop="content">
          <el-input
            type="textarea"
            v-model="tempData.content"
            :autosize="{ minRows: 2, maxRows: 8 }"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="jdialog-footer">
      <div class="popbtn has_bg" @click="saveTemt">保存</div>
      <div class="popbtn" @click="closeWin">关闭</div>
    </div>
  </el-dialog>
</template>

<script>
import request from "@/utils/request";
import { deepClone, isNull } from "@/utils/util";
export default {
  name: "comboGridWidget",
  props: {
    tempDialogVisible: {
      type: Boolean,
      default: false,
    },
    tempCode: {
      type: String,
      default: "",
    },
    tempSaveUrl: {
      type: String,
      default: "/jumper-mih/nt/ntBaseTemplate/save",
    },
    fieldModel: {
      type: Array,
      default: new Array(),
    },
    template: {
      type: Object,
      default: {},
    },
    tempName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tempData: {
        name: "",
        content: "",
      },
      visible: false,
      disabled:false
    };
  },
  watch: {
    tempDialogVisible(val) {
      if (val) {
        this.tempData.name=this.tempName=='多文本输入'?'':this.tempName.replace(/(.*):/,'$1').replace(/(.*)：/,'$1')
        this.disabled=this.tempName=='多文本输入'?false:true
        this.tempData.content=''
        // if (this.fieldModel.length > 0) {
        //   this.tempData.content = this.fieldModel[this.fieldModel.length - 1];
        // }
      }
    },
  },
  created() {
  },
  beforeDestroy() {},
  methods: {
    closeWin() {
      this.tempData = {
        name: "",
        content: "",
      };
      this.$emit("update:tempDialogVisible", false);
    },
    saveTemt() {
      if(window.apiConfig.key!='baoan'){
        this.$http({
          url: this.$http.adornUrl("/ntApi/handleRequest"), // 孕保系统固定请求此地址
          data: this.$http.adornData({
            uri: this.tempSaveUrl || '/jumper-mih/nt/ntBaseTemplate/save', // 实际请求的外部系统api路径
            type: "post",
            params: {
              templateType: this.tempData.name,
              code: this.template.code || this.tempCode,
              content: this.tempData.content,
              // title: this.tempData.name,
              templateRange: 2,
              state: 0,
            },
          }),
        }).then((response) => {
          if (response.data.code == 0) {
            this.closeWin();
          }
        });
      }else{
        this.$http({
          url: `${this.tempSaveUrl}`,
          method: 'post',
          data: {
            templateType: this.tempData.name,
            code: this.template.code || this.tempCode,
            content: this.tempData.content,
            // title: this.tempData.name,
            templateRange: 2,
            state: 0,
          }
        }).then((response) => {
          if (response.data.code == 0) {
            this.closeWin();
          }
        });

      }

    },
  },
};
</script>
<style  lang="scss" scoped>
.jdialog-content {
  overflow: hidden;
  overflow-y: auto;
}
.jdialog-footer {
  margin-top: 25px;
  text-align: center;
}

.popbtn {
  min-width: 80px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  border-radius: 20px;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  color: #409eff;
  margin: 0 15px;
  vertical-align: middle;
  box-sizing: border-box;
  padding: 0 25px;
  border: 1px solid;
}

.popbtn.has_bg {
  background: #409eff;
  color: #fff;
}
::v-deep .el-dialog__header {
  padding: 0;
  background: #409eff;
  text-align: center;
}

::v-deep .el-dialog__title {
  line-height: 20px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
}

::v-deep .el-dialog__body {
  padding: 20px 30px 10px;
}

::v-deep .el-dialog__header span.el-dialog__title {
  font-size: 14px !important;
}
::v-deep .el-dialog__headerbtn {
  right: 10px;
  top: 0px;
}
</style>
